'use client';

import React, { PropsWithChildren } from 'react';

import { AuthProvider } from '@/providers/auth-provider/auth-provider';
import NotificationBannerProvider from '@/providers/notification-banner-provider';
import ProgressProvider from '@/providers/progress-provider';
import RollbarProvider from '@/providers/rollbar-provider';
import StoreProvider from '@/providers/store-provider';
import ThemeProvider from '@/providers/theme-provider';
import { StoreInterface } from '@/stores/store';
import { User } from '@/typings/user';

type Props = {
  initialStoreData?: Partial<Omit<StoreInterface, 'updateData'>>;
  user?: User;
};

let counter = 0;

const Providers: React.FC<PropsWithChildren<Props>> = ({
  children,
  initialStoreData = {},
  user,
}) => {
  console.log('Providers', ++counter);

  return (
    <RollbarProvider>
      <StoreProvider initialData={{ ...initialStoreData }}>
        <AuthProvider initialUser={user}>
          <ThemeProvider>
            <ProgressProvider>
              <NotificationBannerProvider>{children}</NotificationBannerProvider>
            </ProgressProvider>
          </ThemeProvider>
        </AuthProvider>
      </StoreProvider>
    </RollbarProvider>
  );
};

export default Providers;
